import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import { isEditable } from '@syncfusion/ej2-react-grids';
import React, { useEffect, useState } from 'react';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

const yesNoOptions = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
  { value: '', label: 'Not Assessed' },
];

const ForestSourcingAreasOptions = [
  { value: 'Antrim', label: 'Antrim' },
  { value: 'Armagh', label: 'Armagh' },
  { value: 'Carlow', label: 'Carlow' },
  { value: 'Cavan', label: 'Cavan' },
  { value: 'Clare', label: 'Clare' },
  { value: 'Cork', label: 'Cork' },
  { value: 'Derry', label: 'Derry' },
  { value: 'Donegal', label: 'Donegal' },
  { value: 'Down', label: 'Down' },
  { value: 'Dublin', label: 'Dublin' },
  { value: 'Fermanagh', label: 'Fermanagh' },
  { value: 'Galway', label: 'Galway' },
  { value: 'Kerry', label: 'Kerry' },
  { value: 'Kildare', label: 'Kildare' },
  { value: 'Kilkenny', label: 'Kilkenny' },
  { value: 'Laois', label: 'Laois' },
  { value: 'Leitrim', label: 'Leitrim' },
  { value: 'Limerick', label: 'Limerick' },
  { value: 'Longford', label: 'Longford' },
  { value: 'Louth', label: 'Louth' },
  { value: 'Mayo', label: 'Mayo' },
  { value: 'Meath', label: 'Meath' },
  { value: 'Monaghan', label: 'Monaghan' },
  { value: 'Offaly', label: 'Offaly' },
  { value: 'Roscommon', label: 'Roscommon' },
  { value: 'Sligo', label: 'Sligo' },
  { value: 'Tipperary', label: 'Tipperary' },
  { value: 'Tyrone', label: 'Tyrone' },
  { value: 'Waterford', label: 'Waterford' },
  { value: 'Westmeath', label: 'Westmeath' },
  { value: 'Wexford', label: 'Wexford' },
  { value: 'Wicklow', label: 'Wicklow' },
];

const SupplierTypeOptions = [
  { value: 'Sawmill', label: 'Sawmill' },
  { value: 'Forest', label: 'Forest' },
  { value: 'Hedgerow', label: 'Hedgerow' },
  { value: 'Site Clearanc', label: 'Site Clearanc' },
  { value: 'Storage', label: 'Storage' },
  { value: 'N/A', label: 'N/A' },
];

const ContractWithOptions = [
  { value: 'ECC', label: 'ECC' },
  { value: 'Murrays', label: 'Murrays' },
  { value: 'Coillte', label: 'Coillte' },
  { value: 'SWS', label: 'SWS' },
  { value: 'IFU', label: 'IFU' },
  { value: 'Private', label: 'Private' },
  { value: 'Other', label: 'Other' },
];

const HarvestedByOptions = [
  { value: 'WTG', label: 'WTG' },
  { value: 'ECC', label: 'ECC' },
  { value: 'Murrays', label: 'Murrays' },
  { value: 'Other', label: 'Other' },
];

let certificationInfoInputKeys = [
  {
    name: 'contractUniqueID',
    typeOfInp: 'input',
    label: 'Contract Unique ID',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
    isEditable: true,
  },
  {
    name: 'forestSourcingArea',
    typeOfInp: 'select',
    label: 'Forest Sourcing Area',
    textFieldType: 'text',
    isTextArea: false,
    dropDownData: yesNoOptions,
    width: 4,
  },
  {
    name: 'supplierType',
    typeOfInp: 'select',
    label: 'Supplier Type',
    textFieldType: 'text',
    isTextArea: false,
    dropDownData: SupplierTypeOptions,

    width: 4,
  },
  {
    name: 'validSelfDeclaration',
    typeOfInp: 'select',
    label: 'Valid Self Declaration',
    dropDownData: yesNoOptions,
    width: 4,
  },
  {
    name: 'biomassSite',
    typeOfInp: 'select',
    label: 'Biomass Site',
    dropDownData: yesNoOptions,
    width: 4,
  },
  {
    name: 'forestGrower',
    typeOfInp: 'select',
    label: 'Forest Grower',
    textFieldType: 'text',
    isTextArea: false,
    dropDownData: [],
    width: 4,
  },
  {
    name: 'contractWith',
    typeOfInp: 'select',
    label: 'Contract With',
    textFieldType: 'text',
    isTextArea: false,
    dropDownData: ContractWithOptions,
    width: 4,
  },
  {
    name: 'harvestedBy',
    typeOfInp: 'select',
    textFieldType: 'text',
    isTextArea: false,
    dropDownData: HarvestedByOptions,

    width: 4,
  },
  {
    name: 'tripartiteAgreement',
    typeOfInp: 'select',
    label: 'Tripartite Agreement',
    dropDownData: yesNoOptions,
    width: 4,
  },
  {
    name: 'notes',
    typeOfInp: 'input',
    label: 'Notes',
    textFieldType: 'text',
    isTextArea: true,
    width: 12,
  },
];
let coillteInfoInputKey = [
  {
    name: 'harvestingRate',
    typeOfInp: 'input',
    label: 'Harvesting Rate',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'harvestingMeasurementType',
    typeOfInp: 'input',
    label: 'Harvesting Measurement Type',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'harvestingAssest',
    typeOfInp: 'input',
    label: 'Harvesting Asset',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'forwardingRate',
    typeOfInp: 'input',
    label: 'Forwarding Rate',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'forwardingMeasurementType',
    typeOfInp: 'input',
    label: 'Forwarding Measurement Type',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'forwardingAssest',
    typeOfInp: 'input',
    label: 'Forwarding Asset',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'coillteRoadsideRate',
    typeOfInp: 'input',
    label: 'Coillte Roadside Rate',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'shortStakesPremium',
    typeOfInp: 'input',
    label: 'Short Stakes Premium',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'coillteRateConfirmedBy',
    typeOfInp: 'input',
    label: 'Coillte Rate Confirmed By',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
];
let invoicingRatesInputKey = [
  {
    name: 'harvestingRate',
    typeOfInp: 'input',
    label: 'Harvesting Rate',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'harvesting_UOM',
    typeOfInp: 'input',
    label: 'Harvesting UOM',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'harvestingConfirmedBy',
    typeOfInp: 'input',
    label: 'Harvesting Confirmed By',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'harvestingNote',
    typeOfInp: 'input',
    label: 'Harvesting Note',
    textFieldType: 'text',
    isTextArea: true,
    width: 12,
  },

  {
    name: 'harvestingEmail',
    typeOfInp: 'input',
    label: 'Harvesting Email',
    textFieldType: 'email',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'forwardingRate',
    typeOfInp: 'input',
    label: 'Forwarding Rate',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'forwarding_UOM',
    typeOfInp: 'input',
    label: 'Forwarding UOM',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'forwardingNote',
    typeOfInp: 'input',
    label: 'Forwarding Note',
    textFieldType: 'text',
    isTextArea: true,
    width: 12,
  },
  {
    name: 'forwardingConfirmedBy',
    typeOfInp: 'input',
    label: 'Forwarding Confirmed By',
    textFieldType: 'text',
    isTextArea: false,
    width: 6,
  },
  {
    name: 'forwardingEmail',
    typeOfInp: 'input',
    label: 'Forwarding Email',
    textFieldType: 'email',
    isTextArea: false,
    width: 6,
  },
];
let productDetailsInputKey = [
  {
    name: 'productGroup',
    typeOfInp: 'input',
    label: 'Product Group',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'purchasePrice',
    typeOfInp: 'input',
    label: 'Purchase Price',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'productSource',
    typeOfInp: 'input',
    label: 'Product Source',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'estimatedQty',
    typeOfInp: 'input',
    label: 'Estimated Quantity',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'destination',
    typeOfInp: 'input',
    label: 'Destination',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
];
let ratesInputKey = [
  {
    name: 'harvestingRate',
    typeOfInp: 'input',
    label: 'Harvesting Rate',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'harvestingMeasurementType',
    typeOfInp: 'input',
    label: 'Harvesting Measurement Type',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'harvestingAssest',
    typeOfInp: 'input',
    label: 'Harvesting Asset',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'harvestExtractingRate',
    typeOfInp: 'input',
    label: 'Harvest Extracting Rate',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'harvestExtractingMeasurementType',
    typeOfInp: 'input',
    label: 'Harvest Extracting Measurement Type',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'harvestExtractingAssest',
    typeOfInp: 'input',
    label: 'Harvest Extracting Asset',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'extractionRate',
    typeOfInp: 'input',
    label: 'Extraction Rate',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'extractionMeasurementType',
    typeOfInp: 'input',
    label: 'Extraction Measurement Type',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'extractionAssest',
    typeOfInp: 'input',
    label: 'Extraction Asset',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'haulage',
    typeOfInp: 'input',
    label: 'Haulage',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'chipping',
    typeOfInp: 'input',
    label: 'Chipping',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
];

let contractQuestionnaireKey = [
  {
    name: 'firstThinnings',
    typeOfInp: 'select',
    label: 'First Thinnings',
    dropDownData: yesNoOptions,
    width: 4,
  },
  {
    name: 'secondThinnings',
    typeOfInp: 'select',
    label: 'Second Thinnings',
    dropDownData: yesNoOptions,
    width: 4,
  },
  {
    name: 'clearFell',
    typeOfInp: 'select',
    label: 'Clear Fell',
    dropDownData: yesNoOptions,
    width: 4,
  },
  {
    name: 'treesLeftPerHectareIfDiff',
    typeOfInp: 'input',
    label: 'Trees Left Per Hectare (If Diff)',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'noteIfYouNeedDifferentQtys',
    typeOfInp: 'input',
    label: 'Notes (Different Qtys)',
    textFieldType: 'text',
    isTextArea: true,
    width: 12,
  },
  {
    name: 'doYouRequireHardCopy',
    typeOfInp: 'select',
    label: 'Require Hard Copy',
    dropDownData: yesNoOptions,
    width: 4,
  },
  {
    name: 'archaeologicalArea',
    typeOfInp: 'select',
    label: 'Archaeological Area',
    dropDownData: yesNoOptions,
    width: 4,
  },
  {
    name: 'recreationalArea',
    typeOfInp: 'select',
    label: 'Recreational Area',
    dropDownData: yesNoOptions,
    width: 4,
  },
  {
    name: 'waterways',
    typeOfInp: 'select',
    label: 'Waterways',
    dropDownData: yesNoOptions,
    width: 4,
  },
  {
    name: 'powerOrPhoneLines',
    typeOfInp: 'select',
    label: 'Power / Phone Lines',
    dropDownData: yesNoOptions,
    width: 4,
  },
  {
    name: 'railLines',
    typeOfInp: 'select',
    label: 'Rail Lines',
    dropDownData: yesNoOptions,
    width: 4,
  },
  {
    name: 'nearbyDwellings',
    typeOfInp: 'select',
    label: 'Nearby Dwellings',
    dropDownData: yesNoOptions,
    width: 4,
  },
  {
    name: 'otherPleaseDetail',
    typeOfInp: 'input',
    label: 'Other (Detail)',
    textFieldType: 'text',
    isTextArea: true,
    width: 12,
  },
  {
    name: 'isPermitDocRequired',
    typeOfInp: 'select',
    label: 'Permit Doc Required',
    dropDownData: yesNoOptions,
    width: 4,
  },
  {
    name: 'isSupplierDocRequired',
    typeOfInp: 'select',
    label: 'Supplier Doc Required',
    dropDownData: yesNoOptions,
    width: 4,
  },
];

let accountInfoInputKeys = [
  {
    name: 'accountHolderName',
    typeOfInp: 'input',
    label: 'Account Holder Name',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'bankName',
    typeOfInp: 'input',
    label: 'Bank Name',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'bic',
    typeOfInp: 'input',
    label: 'BIC',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'iban',
    typeOfInp: 'input',
    label: 'IBAN',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
];

function camelCaseToLabel(text) {
  return text
    .replace(/([A-Z])/g, ' $1') // Add space before capital letters
    .replace(/^./, str => str.toUpperCase()); // Capitalize the first letter
}
const EditContractTableData = ({ open, setOpen, sectionName, sectionData, handleEditSave }) => {
  const [formData, setFormData] = useState(sectionData);
  const [forestGrowerDropdown, setForestGrowerDropdown] = useState([]);

  const handleChange = (key, value) => {
    setFormData(prev => ({ ...prev, [key]: value }));
  };
  const handleClose = () => {
    setOpen(false);
    setFormData({});
  };
  useEffect(() => {
    console.log(sectionData);
    if (open) {
      setFormData(sectionData);
    }
  }, [sectionData, open]);

  useEffect(() => {
    async function getForestGrower() {
      const res = await customAxios.get('/CRM/GetContacts?id=1', { headers: authHeader() });

      const data = res.data.map(item => ({
        value: `${item.crmContactFirst ?? ''} ${item.crmContactLast ?? ''}`.trim(), // String(item.crmId),
        label: `${item.crmContactFirst ?? ''} ${item.crmContactLast ?? ''}`.trim(),
      }));
      setForestGrowerDropdown(data);
    }

    getForestGrower();
  }, []);

  const handleSave = () => {
    console.log(formData, 'formData');
    handleEditSave({ ...formData });
  };

  const getInputArrayList = () => {
    if (sectionName == 'certificationInfo') {
      return certificationInfoInputKeys;
    }
    // else if (sectionName == 'coillteInfo') {
    //   return coillteInfoInputKey;
    // }
    else if (sectionName == 'invoicingRates') {
      return invoicingRatesInputKey;
    }
    // else if (sectionName == 'productDetails') {
    //   return productDetailsInputKey;
    // }
    else if (sectionName == 'rates') {
      return ratesInputKey;
    } else if (sectionName == 'contractQuestionnaire') {
      return contractQuestionnaireKey;
    } else if (sectionName == 'accountInfo') {
      return accountInfoInputKeys;
    } else {
      return [];
    }
  };

  if (sectionName === 'coillteInfo') {
    return null;
  }

  if (sectionName === 'productDetails') {
    return null;
  }

  return (
    <Dialog maxWidth="xl" open={open} onClose={handleClose} disableEscapeKeyDown={true}>
      <DialogTitle>
        <Typography style={{ fontSize: '1.5rem' }} component="div">
          {' '}
          Edit {camelCaseToLabel(sectionName)}
        </Typography>
      </DialogTitle>
      <DialogContent style={{ width: '60vw' }}>
        <Box
          noValidate
          component="div"
          className="SiteInfoDialog"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            m: 'auto',
            width: '100%',
            gap: '1rem',
          }}>
          <Grid container spacing={3}>
            {getInputArrayList().map((inputProps, index) => (
              <Grid item xs={12} sm={6} md={inputProps.width || 4} key={`${inputProps.name}_${index}`}>
                {inputProps.typeOfInp == 'select' && (
                  <TextField
                    variant="outlined"
                    select
                    fullWidth
                    label={inputProps.label}
                    value={formData[inputProps.name] ?? ''}
                    onChange={e => handleChange(inputProps.name, e.target.value)}
                    SelectProps={{
                      MenuProps: {
                        disablePortal: true,
                        anchorOrigin: {
                          vertical: 'bottom',
                          horizontal: 'left',
                        },
                        transformOrigin: {
                          vertical: 'top',
                          horizontal: 'left',
                        },
                        getContentAnchorEl: null, // only needed in older versions of MUI
                      },
                    }}>
                    {(inputProps.name === 'forestGrower' ? forestGrowerDropdown : inputProps.dropDownData).map(menuItem => (
                      <MenuItem key={menuItem.value} value={menuItem.value}>
                        {menuItem.label}
                      </MenuItem>
                    ))}

                    {/* <MenuItem value="0">No</MenuItem>
                      <MenuItem value="">Not Assesed</MenuItem> */}
                  </TextField>
                )}
                {inputProps.typeOfInp == 'input' && (
                  <TextField
                    variant="outlined"
                    type={inputProps.textFieldType || 'text'}
                    fullWidth
                    label={inputProps.label}
                    value={formData[inputProps.name] ?? ''}
                    onChange={e => handleChange(inputProps.name, e.target.value)}
                    multiline={inputProps.isTextArea}
                    InputLabelProps={{ shrink: true }}
                  />
                )}

                {/* </FormControl> */}
              </Grid>
            ))}
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="contained" color="primary" onClick={handleSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditContractTableData;
